import type { ReactNode } from 'react';
import { Skeleton } from '../../../components/ui/Skeleton.js';

export interface ChartShellProps {
  readonly title: string;
  readonly accent: string;
  readonly loading?: boolean;
  readonly empty?: boolean;
  readonly children: ReactNode;
}

export function ChartShell({
  title,
  accent,
  loading,
  empty,
  children,
}: ChartShellProps): JSX.Element {
  return (
    <section
      className="rounded-md border border-border overflow-hidden"
      style={{ backgroundColor: '#0F1923' }}
    >
      <header className="px-4 py-2 border-b border-border flex items-center justify-between">
        <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-text-dim">{title}</h3>
        <span
          aria-hidden
          className="h-2 w-2 rounded-sm"
          style={{ backgroundColor: accent }}
        />
      </header>
      <div className="h-[200px] p-2">
        {loading ? (
          <Skeleton className="h-full w-full" />
        ) : empty ? (
          <div className="h-full grid place-items-center text-xs text-text-dim">
            No data in this window.
          </div>
        ) : (
          children
        )}
      </div>
    </section>
  );
}

export const CHART_GRID_COLOR = '#1A2D42';
export const CHART_AXIS_COLOR = '#4A6880';
